(() => {
  const menuTabs = document.querySelectorAll('[data-menu-solution] .menu_item__tabs_item');
  const setTabs = el => !el.classList.contains('active') && menuTabs.forEach(tab => tab.classList.toggle('active', el === tab));

  menuTabs.length && menuTabs.forEach(tab => {
    tab.addEventListener('mouseenter', () => {
      setTabs(tab);
      tab.click();
    });
    tab.addEventListener('click', () => setTabs(tab));
  });
})();
